/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** ChangeStatusPayload */
export interface ChangeStatusPayload {
  /**
   * Status reported in StatusNotification.req. A status can be reported for
   * the Charge Point main controller (connectorId = 0) or for a specific
   * connector. Status for the Charge Point main controller is a subset of the
   * enumeration: Available, Unavailable or Faulted.
   *
   * States considered Operative are: Available, Preparing, Charging,
   * SuspendedEVSE, SuspendedEV, Finishing, Reserved.
   * States considered Inoperative are: Unavailable, Faulted.
   */
  status: ChargePointStatus;
}

/** ChargePointResponse */
export interface ChargePointResponse {
  /** Cpid */
  cpid: string;
  /** Host Name */
  host_name: string;
  /** Host Value */
  host_value: string;
  /** Vendor */
  vendor: string;
  /** Model */
  model: string;
  /**
   * Status reported in StatusNotification.req. A status can be reported for
   * the Charge Point main controller (connectorId = 0) or for a specific
   * connector. Status for the Charge Point main controller is a subset of the
   * enumeration: Available, Unavailable or Faulted.
   *
   * States considered Operative are: Available, Preparing, Charging,
   * SuspendedEVSE, SuspendedEV, Finishing, Reserved.
   * States considered Inoperative are: Unavailable, Faulted.
   */
  status: ChargePointStatus;
  /** Ct Clamp Current Milliamps */
  ct_clamp_current_milliamps: number;
  /** Ct Clamp Voltage Millivolts */
  ct_clamp_voltage_millivolts: number;
  /** Charge Rate Amps */
  charge_rate_amps: number;
  /** Basic Auth Pw */
  basic_auth_pw?: string;
  /** Running Scenario Name */
  running_scenario_name?: string;
}

/**
 * ChargePointStatus
 * Status reported in StatusNotification.req. A status can be reported for
 * the Charge Point main controller (connectorId = 0) or for a specific
 * connector. Status for the Charge Point main controller is a subset of the
 * enumeration: Available, Unavailable or Faulted.
 *
 * States considered Operative are: Available, Preparing, Charging,
 * SuspendedEVSE, SuspendedEV, Finishing, Reserved.
 * States considered Inoperative are: Unavailable, Faulted.
 */
export enum ChargePointStatus {
  Available = 'Available',
  Preparing = 'Preparing',
  Charging = 'Charging',
  SuspendedEVSE = 'SuspendedEVSE',
  SuspendedEV = 'SuspendedEV',
  Finishing = 'Finishing',
  Reserved = 'Reserved',
  Unavailable = 'Unavailable',
  Faulted = 'Faulted',
}

/** CreatePayload */
export interface CreatePayload {
  /** Host */
  host?: string;
  /** Basic Auth Pw */
  basic_auth_pw?: string;
  /** Vendor */
  vendor?: string;
  /** Model */
  model?: string;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** StartScenarioPayload */
export interface StartScenarioPayload {
  /** Scenario Name */
  scenario_name: string;
}

/** UpdateChargePointPayload */
export interface UpdateChargePointPayload {
  /**
   * Status reported in StatusNotification.req. A status can be reported for
   * the Charge Point main controller (connectorId = 0) or for a specific
   * connector. Status for the Charge Point main controller is a subset of the
   * enumeration: Available, Unavailable or Faulted.
   *
   * States considered Operative are: Available, Preparing, Charging,
   * SuspendedEVSE, SuspendedEV, Finishing, Reserved.
   * States considered Inoperative are: Unavailable, Faulted.
   */
  status: ChargePointStatus;
  /** Ct Clamp Current Milliamps */
  ct_clamp_current_milliamps: number;
  /** Ct Clamp Voltage Millivolts */
  ct_clamp_voltage_millivolts: number;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

export interface GoogleAuthenticationAuthGooglePostParams {
  /** Token */
  token: string;
  /**
   * Status Code
   * @default 201
   */
  status_code?: number;
}
